<form [formGroup]="userForm" autocomplete="off" role="form" class="fieldHeight">
    <div class="float-left bg-white card-background">
      <app-content-top-nav [visibleBackNav]='true' [enableBackNav]='true'></app-content-top-nav>
      <div class="col-md-12 clear-all title-wrapper">
        <h2 class="title-text">This is a dummy page!! </h2>
      </div>
      
        <div class="col-md-12 underline margin-top"></div>
    
  
      <app-content-bottom-nav (onNextHandler)="gotoNextPage()" [userInputDetail]="userInputDetail['buttonConfig']" [buttonType]="'normalCTA'"></app-content-bottom-nav>
    </div>
  </form>
  